import React, { useEffect, useState } from "react";
import Pagination from "../component/Pagination";
import { useNavigate } from "react-router-dom";
import matrimonyInstance from "../utils/axios";
import { LIST_ALL_PROFILES, SEARCH_PROFILE } from "../API_LIST";
import { useDispatch, useSelector } from "react-redux";
import { getDataFromJwt, isAdmin, isUser, isVolunteer } from "../utils/utility";
import ProfileCard from "../component/section/profileCard";
import { Link } from "react-router-dom";
import ROLES from "../utils/constants";
import { setCurrentProfile } from "../redux/features/authSlice";
import { toastMaker } from "../utils/utility";
import PaginationComponent from "../component/section/PaginatedItems";
import ProfileCard2 from "../component/section/profileCard2";
import PageTitle from "./pageTitle";

export default function ProfileFilter() {
	const [isOpenFilter, setIsOpenFilter] = useState(false);
	const profileSelected = useSelector((state) => state.auth.currentProfile);
	const dispatch = useDispatch();
	const roleid = getDataFromJwt("role");
	const [totalCount, setTotalCount] = useState(0);
	const [pageNumber, setPageNumber] = useState(1);
	const [countPerPage, setCountPerPage] = useState(9);
	const [paymentStatus, setPaymentStatus] = useState(null);
	const [fromAge, setFromAge] = useState(null);
	const [toAge, setToAge] = useState(null);
	const [profileId, setProfileId] = useState(null);
	function getParent() {
		if (roleid) {
			return ROLES[roleid].landingUrl;
		}
	}
	const parent = getParent();

	useEffect(() => {
		if (isOpenFilter) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
	}, [isOpenFilter]);
	const navigate = useNavigate();
	const [profilesData, setProfilesData] = useState();
	const [errorMessage, setErrorMessage] = useState();
	const getProfiles = async (customCountPerPage, customPageNumber) => {
		if (!profileSelected && isUser()) {
			let profile = localStorage.getItem("currentProfile");
			if (profile) {
				dispatch(setCurrentProfile(profile));
				getProfiles();
			} else {
				navigate("/login");
			}
		}
		const account_id = getDataFromJwt("id");
		let data = {
			limit: customCountPerPage
				? Number.parseInt(customCountPerPage)
				: countPerPage
					? countPerPage
					: 9,
			page: customPageNumber ? Number.parseInt(customPageNumber) : 1,
		};
		if (fromAge) {
			data.year_from = Number.parseInt(fromAge);
		}
		if (toAge) {
			data.year_to = Number.parseInt(toAge);
		}
		if (profileId) {
			data.search_profile = Number.parseInt(profileId);
		}
		if (isUser() && account_id) {
			if (!profileSelected) return;
			data.account_id = account_id;
			data.profile_id = profileSelected.profile_id;
			data.profile = profileSelected?.profile;
			data.profile_verification_status = "approved";
			data.payment_status = "active";
		}
		if (isAdmin() || isVolunteer()) {
			data.payment_status = paymentStatus;
		}
		console.log({ data });
		matrimonyInstance
			.post(SEARCH_PROFILE, data)
			.then((response) => {
				setTotalCount(response.data.total_count);
				setCountPerPage(response.data.limit);
				setPageNumber(response.data.page_number);
				setProfilesData(response.data.profiles);
			})
			.catch((error) => {
				setTotalCount(0);
				setCountPerPage(0);
				setPageNumber(0);
				setProfilesData([]);
				setErrorMessage(error?.response?.data?.message);
			});
	};

	// useEffect(() => {
	//   getProfiles();
	// }, []);

	useEffect(() => {
		getProfiles();
	}, [profileSelected]);

	console.log();

	function onPageChanged(key, value) {
		if (key == "pageNumber") {
			setPageNumber(value);
			getProfiles(9, value);
		} else if (key == "countPerPage") {
			setCountPerPage(value);
			getProfiles(value, 1);
		}
	}

	function clearFilter() {
		console.log("function called");
		setFromAge("");
		setToAge("");
		setPaymentStatus("");
		setProfileId("");
	}

	return (
		<div id="dashboard">
			<div id="profile-filter" className="pb-30">
				<div className="profile-filter-header">
					<button
						className="btn-filter d-flex align-items-center gap-2 pt-10 pb-10 pl-20 pr-20"
						onClick={() => setIsOpenFilter(!isOpenFilter)}
					>
						<img src="../assets/images/bat-img/filter.svg" />
						<span className="fw-600">Filter</span>
					</button>
					<h5>Profiles Filter</h5>
				</div>

				<div className={`profile-filter-box`}>
					<div className="d-flex justify-content-center pb-30 pt-30 position-relative">
						<div className="profile-card-list">
							<ProfileCard2
								profilesData={profilesData}
								errorMessage={errorMessage}
								showShortList={true}
							/>
						</div>
						<div
							className={`profile-filter-group content
                }`}
							style={{ width: `${isOpenFilter ? "300px" : "0px"}` }}
						>
							<p className="profile-filter-group-title">
								<div className="d-flex justify-content-between align-items-center">
									<p>Filter</p>
									<img
										src="../assets/images/bat-img/close-filter.svg"
										onClick={() => setIsOpenFilter(!isOpenFilter)}
										className="cursor-pointer"
									/>
								</div>
							</p>

							<div
								className="pl-20 pr-20 pb-50"
								style={{
									overflowY: "scroll",
									// scrollbarWidth: "thin",
									maxHeight: "500px",
								}}
							>
								<div className="profile-filter-group-title-checkbox">
									{/* <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label className="form-check-label" for="flexCheckDefault">
                      Photos
                    </label>
                  </div> */}
									{isAdmin() || isVolunteer() ? (
										<div>
											<p className="mb-10">Payment Status</p>
											<select
												class="form-select"
												onChange={(e) => setPaymentStatus(e.target.value)}
												value={paymentStatus}
											>
												<option value={""}>All</option>
												<option value={"active"}>Active</option>
												<option value={"expired"}>Expired</option>
												<option value={"unpaid"}>Pending</option>
											</select>
										</div>
									) : null}
									{/* {isUser() ? (
                    <div className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        className="form-check-label"
                        for="flexCheckDefault"
                      >
                        My Shortlists
                      </label>
                    </div>
                  ) : null} */}
									{/* <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label className="form-check-label" for="flexCheckDefault">
                      Horoscope
                    </label>
                  </div> */}
									{/* <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label className="form-check-label" for="flexCheckDefault">
                      Divorcee/Widowed
                    </label>
                  </div> */}
									{/* <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label className="form-check-label" for="flexCheckDefault">
                      Physically Challenged
                    </label>
                  </div> */}
								</div>
								{/* <div className="mb-20">
                  <label for="paatham">Sort By</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value="">Recently Created</option>
                  </select>
                </div> */}
								{/* <div className="mb-20">
                  <label for="paatham">NRI</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div> */}
								{/* <div className="mb-20">
                  <label for="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    placeholder=""
                    className="form-control rounded-1 mt-15"
                  />
                </div> */}
								{/* <div className="mb-10">
                  <label for="name">Age</label>
                  <input
                    type="text"
                    id="name"
                    placeholder=""
                    className="form-control rounded-1 mt-15"
                  />
                </div> */}
								<div className="mb-20">
									<p className="mb-15"> Profile id</p>
									<input
										type="number"
										id="name"
										onChange={(e) => setProfileId(e.target.value)}
										value={profileId}
										pattern="^\+?\d{1,5}$"
										placeholder="ex. 11223"
										className="form-control rounded-1 mt-15"
									/>
								</div>
								<div className="mb-20">
									<p className="mb-15"> From Year</p>
									<input
										type="text"
										id="number"
										onChange={(e) => setFromAge(e.target.value)}
										value={fromAge}
										maxLength={4}
										placeholder="ex. 1994"
										className="form-control rounded-1 mt-15"
									/>
								</div>
								<div className="mb-20">
									<p>To Year</p>
									<input
										type="text"
										id="number"
										value={toAge}
										maxLength={4}
										onChange={(e) => setToAge(e.target.value)}
										placeholder="ex. 2001"
										className="form-control rounded-1 mt-15"
									/>
								</div>
								{/* <label>Height</label>
                <div className="d-flex gap-5 mb-20">
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value="From"></option>
                  </select>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value="To"></option>
                  </select>
                </div> */}
								{/* <label>Monthly Salary</label>
                <div className="d-flex gap-5 mb-20">
                  <input
                    type="text"
                    id="name"
                    placeholder="From"
                    className="form-control rounded-1 mt-15"
                  />
                  <input
                    type="text"
                    id="name"
                    placeholder="To"
                    className="form-control rounded-1 mt-15"
                  />
                </div> */}
								{/* <div className="mb-20">
                  <label for="paatham">Home Town</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div> */}
								{/* <div className="mb-20">
                  <label for="paatham">Exclude Hometown</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div> */}
								{/* <div className="mb-20">
                  <label for="paatham">Family Status</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div>
                <div className="mb-20">
                  <label for="paatham">Rasi</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div>
                <div className="mb-20">
                  <label for="paatham">Nakshatram</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div>
                <div className="mb-20">
                  <label for="paatham">Exclude Nakshatram</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div>
                <div className="mb-20">
                  <label for="paatham">Exclude Gothru</label>
                  <select id="paatham" className="form-select rounded-1 mt-15">
                    <option value=""></option>
                  </select>
                </div> */}
								<div className="d-flex justify-content-between">
									<button
										className="btn btn-filter filter-apply"
										onClick={() => getProfiles()}
									>
										Apply
									</button>
									<button
										className="btn btn-filter filter-clear"
										onClick={clearFilter}
									>
										Clear
									</button>
									<button className="btn-filter filter-cancel">Cancel</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<PaginationComponent
					totalCount={totalCount}
					onValueChanged={onPageChanged}
					pageNumber={pageNumber}
					countPerPage={countPerPage}
				/>
				{(roleid === 3 || roleid === 4) && (
					<div className="contact-text mt-10">
						<h6>
							Please contact us via email at{" "}
							<a className="tetx-blue-card" href="mailto:support@batus.org">
								support@batus.org
							</a>{" "}
							or call us at{" "}
							<a className="tetx-blue-card" href="tel:+1 707 564 6228">
								+1 707 564 6228
							</a>{" "}
							for more details about your selected profile. Kindly mention the
							profile number when reaching out.
						</h6>
					</div>
				)}
			</div>
		</div>
	);
}
